// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1H0te","large":"styles_large__39UbX"};